type Inputs = {
    editorElement: HTMLElement;
    inputElement: HTMLInputElement;
};

// Mirrors the editor's HTML into the hidden form field that gets submitted.
export function syncToInput({ editorElement, inputElement }: Inputs): void {
    inputElement.value = editorElement.innerHTML;
}
